import { render, staticRenderFns } from "./supplierList_shanghai.vue?vue&type=template&id=b595cdd2&scoped=true&"
import script from "./supplierList_shanghai.vue?vue&type=script&lang=js&"
export * from "./supplierList_shanghai.vue?vue&type=script&lang=js&"
import style0 from "./supplierList_shanghai.vue?vue&type=style&index=0&id=b595cdd2&scoped=true&lang=css&"
import style1 from "./supplierList_shanghai.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b595cdd2",
  null
  
)

export default component.exports